import { find } from 'lodash/fp'

import { SystemState } from '../../types/store'

export const getPlayers = (state: SystemState) => state.players
export const getPlayerById = (state: SystemState, id: string) => find((player) => player.id === id, state.players)
